import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const ChapterHeading = ({ number, label }) => (
  <div className="flex items-center gap-4 mb-6">
    <span className="font-mono text-xs text-amber tracking-widest">{number}</span>
    <span className="h-px flex-1 max-w-[64px] bg-amber/50"></span>
    <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/50">
      {label}
    </span>
  </div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-xs uppercase tracking-[0.35em] text-amber mb-6 flex items-center gap-3">
    <span className="w-8 h-px bg-amber"></span>
    {children}
  </p>
);
